export const cleanTitle = (title) => {
    if (!title) return '';
    return title
        .replace(/^\s*(?:\|?\s*FR\s*\|?|FRENCH|VF|VOSTFR)\s*[-_:|•]+\s*/i, '')
        .replace(/^\s*(?:SRS|SERIES|SÉRIES)\s*[-_:|•]+\s*/i, '')
        .replace(/\bSRS\s*-\s*SERIES\s*\d*\b/gi, '')
        .replace(/\bSRS\s*-\s*/gi, '')
        .replace(/\s*-\s*SRS\b/i, '')
        .replace(/\bSRS\b/gi, '')
        .replace(/\s*\((?:FR|US|GB|UK|CA|JP|KR|DE|ES|IT|BE|CH|NO|SE|DK|NL|IL|UA|QA)\)\s*$/i, '')
        .replace(/\s*\[(?:FR|VF|VOSTFR|MULTI|TRUEFRENCH|FRENCH)\]\s*/gi, ' ')
        .replace(/\s*\b(?:TRUEFRENCH|FRENCH|MULTI|VF2|VFQ|VFF|VOSTFR)\b\s*/gi, ' ')
        .replace(/\s*\(\d{4}\).*$/, '')
        .replace(/^[\s\-_|•]+|[\s\-_|•]+$/g, '')
        .replace(/\s{2,}/g, ' ')
        .trim();
};

export const getContentDuplicateKey = (content, fallbackType = '') => {
    const title = cleanTitle(content?.title || content?.name || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    const type = content?.type || content?.categoryType || fallbackType || '';
    return title ? `${type}:${title}` : `${type}:${content?.id || content?.stream_id || content?.series_id || content?.num || ''}`;
};

const PLATFORM_KEYWORDS = [
    'netflix', 'disney', 'prime', 'apple', 'hbo', 'max', 'paramount',
    'hulu', 'canal', 'tf1', 'm6', 'ocs', 'universal', 'warner',
    'sony', 'mgm', 'lionsgate', 'sky', 'starz', 'showtime', 'dazn'
];

export const getCategoryWeight = (title) => {
    if (!title) return 0;
    const normalizedTitle = title.toLowerCase();
    if (normalizedTitle.includes('récemment') || normalizedTitle.includes('nouveautés') || normalizedTitle.includes('tendances')) {
        return -1;
    }
    if (PLATFORM_KEYWORDS.some((keyword) => normalizedTitle.includes(keyword))) {
        return 1;
    }
    return 0;
};

export const cleanCategoryName = (name) => {
    if (!name) return '';
    return name
        .replace(/^(SRS\s*-\s*SERIES\s*\d*|SRS\s*-\s*SERIES|SRS|VOD|MOVIES|SERIES|SÉRIES|FILMS|NETFLIX|DISNEY\+|APPLE\s*TV|PRIME\s*VOD)\s*[:\-\s|]*/i, '')
        .replace(/\s*[[()].*?[\])]/g, '')
        .replace(/\s*-\s*VOD$/i, '')
        .replace(/\bRÉCEMMENT\s+AJOUTER\b/i, 'RÉCEMMENT AJOUTÉS')
        .replace(/^[\s\-_|]+|[\s\-_|]+$/g, '')
        .trim()
        .toUpperCase();
};
